import React from 'react';
import { Link } from 'react-router-dom';
import { Footer , Header} from '../index';
import './formstage.css'



    function Formoffre() {
       
    return (
        <>
        <Header/>
  
         <div className='containerstages'>
        <div className='bgstages'>  </div>
        <div className='ligne2'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-260px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'55px'}}className="container-fluid text-white text-center " id='h1stage'>Déposer un offre d'Emploi</h1>
          <p ><Link className='linkIng' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkIng'
            to="/"> Entreprises </Link>  <span>{'>'}</span> <Link className='linkIng'
            to="/">Offre D'emploi</Link> </p></div>
      </div>


 <div className="containerstage">
  <form >
  <div className="row">
      <div className="col-50">
        <label  className='titrelabel'>Informations sur l'entreprise</label>
      </div>
      
    </div>
    <div className="row">
      <div className="col-25">
        <label for="fname">Entreprise</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="fname" name="firstname" placeholder="nom de l'Entreprise "/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Responsable (CEO)</label>
      </div>
      <div className="col-75">
        <input className="textstage"type="text" id="lname" name="lastname" placeholder="nom du Responsable"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Fax</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" placeholder="votre fax"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Téléphone</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" placeholder="votre téléphone"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">E-mail</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" placeholder="votre adresse email"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Site Web</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" placeholder="votre site web / page facebook"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Adresse</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" placeholder="votre adresse"/>
      </div>
    </div>
    <div className="row">
      <div className="col-50">
        <label className='titrelabel'>Informations sur l'Offre d'Emploi </label>
      </div>
      
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Offre</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" placeholder="le sujet / besoin"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="subject">Domaine</label>
      </div>
      <div className="col-75">
      <input className="textstage" type="text" id="lname" name="lastname" placeholder="le domaine"/>
        <textarea id="subject" name="subject" placeholder="votre description" style={{height:'200px',marginTop:'10px'}}></textarea>
      </div>
    </div>
    <div className="row inputsubmitstage">
      <input className="submitform" type="submit" value="Envoyer"/>
    </div>
  </form>
</div>

        
        <Footer/>
        </>

    ) ;
}

export default Formoffre;